<template>
    <div>
        <template v-if="is_admin === true">
            <div class="page-top mb-1 mb-3 align-center clearfix">
                <h1 class="float-left"> FAQs </h1>
                <router-link to="/addFaq" class="btn btn-primary float-right active"> Add New FAQ</router-link>
                <div class="searching float-right mr-2">
                    <input id="customSearch" type="text" class="form-control search" name="" />
                </div>
            </div>
            <table id="faqTable" class="table">
                <thead>
                <tr>
                    <th style="display: none;"></th>
                    <th>Category</th>
                    <th>Question</th>
                    
                    <th class="text-center">Action</th>
                </tr>
                </thead>
            </table>
        </template>

        <template v-if="is_admin === false">
        
    <div class="">
		<div class="page-top mb-1 mb-3 clearfix text-center">
			<h1> Questions? Look here. </h1>
			<p>Can't find an answer ? call us at (042) 38100050 or email contact@finja.pk!</p>
		</div>
		<div class="global-main faq-main">
			<div class="page-top mb-1 mb-4 clearfix">
				<ul class="nav nav-tabs nav-tabs-2 justify-content-center" id="myTab" role="tablist">
					
                    <li class="nav-item" v-for="(faqCategory,index) in faqCategories" :key="faqCategory.id">
						<a class="nav-link " :class="{ 'active': '0' == index}" id="" data-toggle="tab" :href="'#tab'+faqCategory.id" role="tab" aria-controls="new" aria-selected="true">{{faqCategory.name}}</a>
					</li>

				</ul>
			</div>
			<div class="tab-content" id="myTabContent">

				<div class="tab-pane fade show" role="tabpanel" v-for="(faq,index) in faqs" :id="'tab'+faq.id" :key="faq.id" :class="{ 'active': '0' == index}">
					<div class="faq-content">
						<div class="accordion">
							<div v-if="faq.faqs.length > 0">
                                <div class="card" v-for="fq in faq.faqs" :key="fq.id">
                                    <div class="card-header" >
                                        <span class="collapsed" data-toggle="collapse" :data-target="'#col'+fq.id">
                                            {{fq.faq_question}}
                                        </span>
                                    </div>
                                    <div :id="'col'+fq.id" class="collapse ">
                                        <div class="card-body">
                                            {{fq.faq_answer}} 
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <h1>There are no FAQs</h1>
                            </div>
						</div>
                    </div>
				</div>

			</div>
		</div>
	</div>
        </template>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                data : null,
                is_admin: null,
                faqCategories: null,
                faqs: null
            };
        },
        mounted() {
            this.$Progress.start();
            axios.get('/api/getFaqsAPI')
                .then(res => {
                    this.faqCategories = res.data.faqCategories;
                    this.faqs = res.data.faqs;
                    if(res.data.is_admin == true){
                        this.is_admin = true;
                    }else{
                        this.is_admin = false;
                    }
                    this.$Progress.finish();
                }).then(res=> {
                    this.showFaqData();
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                });
        },
        methods:{
            deleteFaq(id){
              swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!',
                    cancelButtonText: 'No, cancel!',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        axios.post('/api/deleteFaqAPI', {id})
                            .then(res => {
                                    if(res.data.status == '200'){
                                        $('#faqTable').DataTable().ajax.reload();
                                        this.showToastBox('success',res.data.msg);
                                    }else{
                                        this.showToastBox('error',res.data.msg);
                                    }
                            })
                            .catch(err => {
                                this.showAlertBox('error','System Not Responding Please Try Again');
                            });
                    } else if (result.dismiss === Swal.DismissReason.cancel){
                        this.showAlertBox('error','Cancelled','Your decision has been cancelled');
                    }
                });
            },
            showFaqData() {
                var companyTable = $('#faqTable').DataTable({
                    "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                    ajax: {
                        "url": "api/listFaqAPI",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id', visible: false},
                        {data: 'faq_categories.name'},
                        {data: 'faq_question'},
                        {data: 'id', sorting: false, render: function(data,type,full){
                                var $url = '/editFaq/'+full['id'];
                                return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" class="action edit"><i class="fas fa-pencil-alt"></i></a>'
                                    + '<a href="javascript:void(0);" onclick="VueComponents.faqComponent.methods.deleteFaq('+full['id']+')"><i class="fas fa-trash"></i></a>';
                            }}
                    ],
                    "order": [[ 0, "desc" ]],
                    "columnDefs": [{
                        className: "text-center",
                        "targets": [ 2 ]
                    }],
                    "initComplete": () => {
                        this.$Progress.finish();
                    }
                });
                $('#customSearch').on( 'keyup', function () {
                    companyTable.search(this.value).draw();
                });
            },

        },
        created() {
            //
        }
    }
</script>
